import { render, staticRenderFns } from "./SignInPhoneStep.vue?vue&type=template&id=5619c33c&lang=pug&"
import script from "./SignInPhoneStep.vue?vue&type=script&lang=ts&"
export * from "./SignInPhoneStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports